import { AdapterFactory } from '../AdapterFactory';

export const masterDataService = AdapterFactory.getMasterDataAdapter();
